export const normalizeNotificationArticleIds = (values = []) => (
    [...new Set((Array.isArray(values) ? values : [])
        .map(value => String(value ?? '').trim())
        .filter(Boolean))]
);

export const validateNotificationAlertTargets = (alerts = []) => {
    const errors = [];

    (Array.isArray(alerts) ? alerts : []).forEach(alert => {
        if (!alert?.countsArticles) return;

        const articleIds = normalizeNotificationArticleIds(alert.target?.articleIds);
        const signalValue = Number(alert.signalValue);

        if (!['articles', 'warehouse'].includes(alert.target?.view)) {
            errors.push(`${alert.id}: Artikel-Alert hat keine passende Zielseite.`);
        }
        if (!articleIds.length) {
            errors.push(`${alert.id}: Artikel-Alert hat keine konkreten Artikel-IDs.`);
        }
        if (!Number.isFinite(signalValue) || signalValue !== articleIds.length) {
            errors.push(`${alert.id}: Alert zählt ${alert.signalValue}, Ziel enthält ${articleIds.length} Artikel.`);
        }
    });

    return errors;
};
